import React from "react";
import { CheckCircle2, XCircle, Users, AlertTriangle } from "lucide-react";

export default function AdminKPIs({ stats }) {
  const cards = [
    { label: "Total Users",   value: stats.total,    icon: Users,          color: "text-slate-300",  bg: "bg-slate-800" },
    { label: "Active",        value: stats.active,   icon: CheckCircle2,   color: "text-emerald-400",bg: "bg-emerald-500/10" },
    { label: "Expiring ≤ 7d", value: stats.expiring, icon: AlertTriangle,  color: "text-amber-400",  bg: "bg-amber-500/10" },
    { label: "Expired",       value: stats.expired,  icon: XCircle,        color: "text-red-400",    bg: "bg-red-500/10" },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      {cards.map(k => (
        <div key={k.label} className="glass rounded-xl p-5 border border-slate-800">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-slate-400 text-xs uppercase font-semibold tracking-wider">{k.label}</div>
              <div className="font-heading text-4xl font-extrabold mt-1">{k.value}</div>
            </div>
            <div className={`p-3 rounded-lg ${k.bg}`}><k.icon className={k.color} size={24} /></div>
          </div>
        </div>
      ))}
    </div>
  );
}
